export default __webpack_public_path__ + "static/media/about-sec-img.c6f68dac.png";